import createTypeStyleVariant from './createTypeStyleVariant'

/** @component */
export default createTypeStyleVariant('display-5')
